<div class="container">
    <div class="card-columns mt-4 mb-4">
        <ng-container *ngFor="let project of projects">
            <div class="card shadow p-3 mb-5 bg-white rounded">
                <img class="card-img-top" src="{{project.image}}" alt="{{project.title}}">
                <div class="card-body">
                    <h5 class="card-title">{{project.title}}</h5>
                    <h5 class="projct-role">{{project.role}}</h5>
                    <h6>Domain :&nbsp; {{project.domain}}</h6>
                    <h6 *ngIf="project.link">Link :&nbsp; <a href="{{project.link}}" target="_blank">click here</a></h6>
                    <p class="card-text">
                        {{project.description}}
                    </p>
                    <p class="card-text">Tech & Stacks : &nbsp;<small class="text-muted">{{project.tech}}</small></p>
                </div>
            </div>
        </ng-container>
    </div>
</div>